/* eslint-disable max-lines */
import { templateDownloadApi } from '@mdm/api/customer/customerPersonResponsibleImport';
import { importMainReportList } from '@mdm/api/targetModdeules/mainReport.js';

export const config = {
    name: 'mainReport',
    searchFields: [
        {
            name: '年份',
            value: 'year',
            type: 'date',
            timeType: 'year',
            format: 'yyyy',
            valueFormat: 'yyyy',
            isFixed: true,
            span: 3
        },
        {
            name: '关联目标类型',
            value: 'goalTypeName',
            type: 'advance',
            advanceConfig: [
                { 'prop': 'goalTypeName', 'value': '类型名称' },
                { 'prop': 'goalTypeCode', 'value': '类型编码' }
            ],
            tableConfig: [
                { 'prop': 'goalTypeCode', 'value': '类型编码' },
                { 'prop': 'goalTypeName', 'value': '类型名称' }
            ],
            method: 'post',
            prefix: '/api-lcrm',
            advanceUrl: '/goal/manage/goalType/page',
            cbParams: ['goalTypeCode#goalTypeCode', 'goalTypeName#goalTypeName'],
            isFixed: true,
            span: 4
        },
        {
            name: '目标状态',
            value: 'goalStatus',
            type: 'select',
            optionNum: 'GOAL_MANAGE_INFO_STATUS',
            isFixed: true,
            span: 4
        },
        {
            name: '责任部门',
            value: 'deptName',
            type: 'advance',
            advanceConfig: [
                { 'prop': 'deptName', 'value': '部门名称' },
                { 'prop': 'deptCode', 'value': '部门编码' }
            ],
            tableConfig: [
                { 'prop': 'deptCode', 'value': '部门编码' },
                { 'prop': 'deptName', 'value': '部门名称' }
            ],
            method: 'post',
            prefix: '/api-lcrm',
            advanceUrl: '/goal/manage/dept/page',
            cbParams: ['deptCode#deptCode', 'deptName#deptName'],
            isFixed: true,
            span: 4
        },
        {
            name: '周期结束时间',
            value: 'cycleEndDateFixed',
            type: 'time',
            time: 'daterange',
            format: 'yyyy-MM-dd',
            startPlaceholder: '周期结束时间从',
            endPlaceholder: '周期结束时间到',
            isFixed: true,
            span: 5
        },
        {
            name: '责任人',
            value: 'userName',
            type: 'advance',
            advanceConfig: [
                { 'prop': 'esusUserNameCn', 'value': '姓名' },
                { 'prop': 'esusLoginName', 'value': '美信号' }
            ],
            tableConfig: [
                { 'prop': 'esusLoginName', 'value': '美信号' },
                { 'prop': 'esusUserNameCn', 'value': '姓名' },
                { 'prop': 'escoCompanyNameCn', 'value': '部门' }
            ],
            prefix: '/api-lcrm',
            advanceUrl: '/crmUser/page',
            cbParams: ['esusUserNameCn#userName', 'esusLoginName#userCode'],
            beforeRequest: (params) => {
                const inputKey = (params.esusUserNameCn ? params.esusUserNameCn : (params.esusLoginName ? params.esusLoginName : '')).trim();
                const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g'); // 中文字符正则
                if (reg.test(inputKey)) {
                    params.esusUserNameCn = inputKey;
                    params.esusLoginName = null;
                } else {
                    params.esusLoginName = inputKey;
                    params.esusUserNameCn = null;
                }
                return params;
            },
            isFixed: false,
            span: 4
        },
        {
            name: '目标指标',
            value: 'kpiName',
            type: 'advance',
            advanceConfig: [
                { 'prop': 'kpiName', 'value': '指标名称' },
                { 'prop': 'kpiCode', 'value': '指标编码' }
            ],
            tableConfig: [
                { 'prop': 'kpiCode', 'value': '指标编码' },
                { 'prop': 'kpiName', 'value': '指标名称' }
            ],
            method: 'post',
            prefix: '/api-lcrm',
            advanceUrl: '/goal/manage/kpi/page',
            cbParams: ['kpiCode#kpiCode', 'kpiName#kpiName'],
            isFixed: false,
            span: 4
        },
        {
            name: '周期类型',
            value: 'goalCycleType',
            type: 'select',
            optionNum: 'GOAL_INFO_CYCLE_TYPE',
            isFixed: false,
            span: 4
        },
        {
            name: '周期开始时间',
            value: 'cycleStartDateFixed',
            type: 'time',
            time: 'daterange',
            format: 'yyyy-MM-dd',
            startPlaceholder: '周期开始时间从',
            endPlaceholder: '周期开始时间到',
            isFixed: false,
            span: 6
        }
    ],
    selection: true,
    index: false,
    columns: [
        {
            label: '目标ID',
            prop: 'id',
            hiddenColumn: true
        },
        {
            label: '目标编码',
            prop: 'goalCode',
            hiddenColumn: true,
            minWidth: 160
        },
        {
            label: '目标名称',
            prop: 'goalName',
            minWidth: 120
        },
        {
            label: '目标层级',
            prop: 'goalLevel',
            type: 'select',
            optionsKey: 'GOAL_MANAGE_INFO_LEVEL',
            minWidth: 100
        },
        {
            label: '关联目标类型编码',
            prop: 'goalTypeCode',
            hiddenColumn: true,
            minWidth: 140
        },
        {
            label: '关联目标类型名称',
            prop: 'goalTypeName',
            minWidth: 120
        },
        {
            label: '周期类型',
            prop: 'goalCycleType',
            type: 'select',
            optionsKey: 'GOAL_INFO_CYCLE_TYPE'
        },
        {
            label: '周期开始时间',
            prop: 'cycleStartDate',
            minWidth: 150
        },
        {
            label: '周期结束时间',
            prop: 'cycleEndDate',
            minWidth: 150
        },
        {
            label: '父目标编码',
            prop: 'parentGoalCode',
            hiddenColumn: true,
            minWidth: 160
        },
        {
            label: '父目标名称',
            prop: 'parentGoalName',
            minWidth: 120
        },
        {
            label: '责任部门编码',
            prop: 'deptCode',
            minWidth: 120
        },
        {
            label: '责任部门名称',
            prop: 'deptName',
            minWidth: 100
        },
        {
            label: '责任人MIP',
            prop: 'userCode',
            minWidth: 110
        },
        {
            label: '责任人名称',
            prop: 'userName'
        },
        {
            label: '目标状态',
            prop: 'goalStatus',
            type: 'select',
            optionsKey: 'GOAL_MANAGE_INFO_STATUS',
            minWidth: 100
        },
        {
            label: '目标描述',
            prop: 'goalDesc',
            minWidth: 100
        },
        {
            label: '目标与指标关联表唯一标识',
            prop: 'manageKpiRelaId',
            hiddenColumn: true,
            minWidth: 165
        },
        {
            label: '关联目标指标编码',
            prop: 'kpiCode',
            hiddenColumn: true,
            minWidth: 140
        },
        {
            label: '目标大类',
            prop: 'goalCategory',
            minWidth: 100
        },
        {
            label: '目标小类',
            prop: 'kpiName',
            minWidth: 120
        },
        {
            label: '目标值',
            prop: 'goalValue'
        },
        {
            label: '指标单位',
            prop: 'kpiUnit',
            hiddenColumn: true
        },
        {
            label: '权重',
            prop: 'weight',
            hiddenColumn: true
        },
        {
            label: '实际完成值',
            prop: 'actualValue',
            hiddenColumn: true
        },
        {
            label: '完成率',
            prop: 'completionRate',
            hiddenColumn: true
        }
    ],
    importConfig: {
        downBtn: true,
        downParams: {
            fileName: '目标主表导入模板.xlsx',
            fileId: 'goalManageInfoAddImport.xlsx'
        },
        downloadApi: templateDownloadApi,
        importApi: importMainReportList
    }
};
